import { useState } from "react"

export const useColor = () => {
  const [companyTheme, setCompanyTheme] = useState({
    first: "#e0070f",
    second: "#ff6b6b",
  })

  return { companyTheme }
}
